<template>
  <app-page-hero-banner
    :title="{
      tag: 'h2',
      text: 'Façonnez l\'avenir de votre entreprise aux côtés des meilleurs',
    }"
  >
    <template #subtitle>
      Des formations en IA, Leadership et Sales animées par des experts en poste
    </template>

    <dl v-if="newHomeEnabled" class="flex flex-wrap gap-4 opacity-90">
      <template v-for="(item, index) in statistics" :key="item.id">
        <div v-if="index > 0" class="border-r opacity-20 max-sm:hidden" />

        <div>
          <dd class="flex items-center gap-1 text-3xl font-extrabold">
            <app-icon
              v-if="item.id === 'rating'"
              class="text-rating"
              icon="ph:star-fill"
            />
            {{ item.value }}
          </dd>
          <dt>{{ item.label }}</dt>
        </div>
      </template>
    </dl>

    <template #append>
      <div class="@container/actions">
        <div class="@xl/actions:flex-nowrap flex flex-wrap gap-4">
          <app-button
            class="@xl/actions:basis-auto basis-full whitespace-nowrap"
            size="xl"
            :to="{
              name: 'formations-slug',
              params: { slug: 'intelligence-artificielle' },
            }"
          >
            Découvrir nos programmes IA
          </app-button>
        </div>
      </div>

      <div v-if="!newHomeEnabled" class="mt-6 md:mt-12">
        <p class="text-balance">
          <span class="mr-2" v-html="$t('brand.rating.average_label')" />
          <app-rating-stars
            class="inline-block align-text-bottom"
            :size="18"
            :value="4.5"
          />
        </p>

        <ul class="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 opacity-90">
          <li v-for="company in companies" :key="company">
            <app-image
              :alt="company"
              class="max-h-[26px] max-w-[90px] grayscale invert md:max-h-[32px] md:max-w-[120px]"
              loading="eager"
              :src="`/images/logos/black-and-white/${company}.svg`"
            />
          </li>
        </ul>
      </div>
    </template>

    <template #cover>
      <video
        autoplay
        class="size-full object-cover"
        disablePictureInPicture
        loop
        muted
        playsinline
        preload="metadata"
        src="https://res.cloudinary.com/dfdgwwkpd/video/upload/v1765807689/brand/home/home_cover_pofhwc.mp4"
      />
    </template>

    <template v-if="newHomeEnabled" #footer>
      <brand-logos-carousel
        class="text-white"
        :items="companies"
        logo-classes="invert grayscale opacity-90"
      >
        <template #title>
          <span v-html="$t('enterprise.page.partner_logos_banner_title')" />
        </template>
      </brand-logos-carousel>
    </template>
  </app-page-hero-banner>
</template>

<script lang="ts" setup>
import { BRAND_KEY_FIGURES } from "~/business-areas/brand/brand-key-figures";

const companies: string[] = [
  "loreal",
  "publicis",
  "ey",
  "orange",
  "bnpp",
  "societe-generale",
  "doctolib",
  "deezer",
  "carrefour",
  "dassault",
  "lvmh",
  "wttj",
];

const statistics = BRAND_KEY_FIGURES;

const newHomeEnabled = useFeatureFlag("new_home");
</script>
